import { render, staticRenderFns } from "./windowOpen.vue?vue&type=template&id=cf5f3bf0&scoped=true&"
import script from "./windowOpen.vue?vue&type=script&lang=js&"
export * from "./windowOpen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5f3bf0",
  null
  
)

export default component.exports